import React from 'react';
import PropTypes from 'prop-types';
// import {
//   EnvelopMark,
// } from 'AppSrc/core/components/common/svg-icons';

const PostChangeCommsLabel = React.memo(({
  text,
  href,
}) => (
  <div className="radio-label-wrap">
    <div>{text}</div>
    {/* <div className="svg-preview-container">
      <span className="svg-container"><EnvelopMark /></span>
      <a href={href ? href : '#'} className="view-button">Preview</a>
    </div> */}
  </div>
));

PostChangeCommsLabel.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
};

export { PostChangeCommsLabel };
